"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_RETRY_CONFIG = {
    threshold: 2,
    baseDelay: 100,
    backoffFactor: 2,
    fuzzFactor: 0
};
exports.default = DEFAULT_RETRY_CONFIG;
//# sourceMappingURL=DEFAULT_RETRY_CONFIG.js.map